import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import * as Yup from 'yup';
import { Button, Form, Icon, Modal, Grid } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import MyTextInput from '../../app/common/form/MyTextInput';
import { editSingleUserById } from '../../app/models/user';
import '../../app/common/MediaQuery/responsive-profile.css';
import MyNewSelectInput from '../../app/common/form/MyNewSelectInput';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import MySelectInput from '../../app/common/form/MySelectInput';

function EditUser() {
  const {
    mediaAssetStore,
    userStore,
    RolesAndPermissionsStore,
    commonStore,
    departmentStore,
  } = useStore();
  const { EditUser } = userStore;
  const { rolesByName, rolesRegistry, loadRoles } = RolesAndPermissionsStore;
  const [, setOpen] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  const {
    userStore: { user },
  } = useStore();
  const phoneRegExp = /^(\+|\d)[0-9]{9,16}$/;
  const [state, setState] = useState('');
  const initialState = {
    id: '',
    displayName: '',
    email: '',
    password: '',
    username: '',
    fullName: '',
    customerName: '',
    departmentName: '',
    addressLine1: '',
    addressLine2: '',
    bio: '',
    country: '',
    state: '',
    phoneNumber: '',
    city: '',
    postalCode: '',
    alternatePhoneNumber: '',
    remarks: '',
    role: '',
    workPosition: '',
    superior: '',
    website: '',
    workDepartment: '',
    workApplicationsKnown: '',
    languagesKnown: '',
    roleId: '',
    isAdmin: true,
    roleName: '',
  };
  const [updateuser, setupdateuser] =
    useState<editSingleUserById>(initialState);

  // setting the values in useEffect
  useEffect(() => {
    if (EditUser?.id !== undefined) {
      setupdateuser({
        id: EditUser.id,
        displayName: EditUser?.displayName,
        email: EditUser?.email,
        password: '',
        username: EditUser?.username,
        fullName: EditUser?.fullName,
        customerName: EditUser?.customerName,
        departmentName: EditUser?.departmentName,
        addressLine1: EditUser?.addressLine1,
        addressLine2: EditUser?.addressLine2,
        phoneNumber: EditUser?.phoneNumber || '',
        bio: '',
        country: EditUser?.country,
        state: EditUser?.state,
        city: EditUser?.city,
        postalCode: EditUser?.postalCode,
        alternatePhoneNumber: EditUser?.alternatePhoneNumber || '',
        remarks: EditUser?.remarks,
        role: EditUser?.role,
        workPosition: EditUser?.workPosition,
        superior: EditUser?.superior,
        website: EditUser?.website,
        workDepartment: EditUser?.workDepartment,
        workApplicationsKnown: EditUser?.workApplicationsKnown,
        languagesKnown: EditUser?.languagesKnown,
        roleId: EditUser?.roleId,
        isAdmin: EditUser?.isAdmin,
        roleName: EditUser?.roleName,
      });
    }
  }, [EditUser]);

  useEffect(() => {
    loadRoles();
  }, [loadRoles]);

  useEffect(() => {
    if (departmentStore.departmentsListByCustomerName.length === 0)
      departmentStore.getDepartmentsByCustomer(user?.customerName || '');
    const departmentList = departmentStore.departmentsListByCustomerName.map(
      (x) => ({
        key: x,
        text: x,
        value: x,
      }),
    );
    setDepartmentOptions(departmentList);
    //eslint-disable-next-line
  }, [departmentStore.departmentsListByCustomerName, user?.customerName]);

  useEffect(() => {
    if (EditUser?.roleId !== undefined) {
      rolesByName.forEach((data: any) => {
        if (EditUser?.roleId === data.id) {
          setState(data.roleName);
        }
      });
    } else {
      setState('');
    }
  }, [EditUser, rolesByName]);
  const handleFormSubmit = async (values: editSingleUserById) => {
    const userId = mediaAssetStore.mediaAsset.userEditId;
    if (userId) {
      rolesByName.map((x) =>
        x.id === values.roleId ? (values.roleName = x.roleName) : null,
      );
      // calling update user passing id and values
      userStore.updateUser(userId, values);
    }
    // closing the modal
    mediaAssetStore.editModalOpen(false, undefined);
    setupdateuser(initialState);
  };
  const resetPassword = () => {
    userStore.resetdefaultpassword(updateuser.id);
    mediaAssetStore.openDeleteUserModal(false, '', '');
  };
  const roleOptions = rolesByName.map((x) => ({
    key: x.id,
    text: x.roleName,
    value: x.id,
  }));
  useEffect(() => {
    if (rolesRegistry.size <= 1) loadRoles();
  }, [rolesRegistry.size, loadRoles]);
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={mediaAssetStore.mediaAsset.editmodal}
    >
      <Modal.Header>
        {' '}
        <Icon
          name="edit"
          //Edit
        />
        {
          (userLanguage[0].UserViewUserEdit.UVUEML01 as any)?.[
            `${commonStore.language.key}`
          ]
        }{' '}
      </Modal.Header>
      <Modal.Content>
        <Formik
          initialValues={updateuser}
          enableReinitialize={true}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
          validationSchema={Yup.object({
            // displayName: Yup.string()
            //   .min(2)
            //   .max(15)
            //   .matches(
            //     /^[aA-zZ\s]+$/,
            //     'Only alphabets are allowed for this field ',
            //   ),
            // username: Yup.string()
            //   .min(2)
            //   .max(70)
            //   .matches(/^\S*$/, 'Whitespace is not allowed'),
            departmentName: Yup.string().required('Please select a department'),
            addressLine1: Yup.string()
              .min(2)
              .max(150)
              .required('Please enter address'),
            addressLine2: Yup.string().min(2).max(150),
            phoneNumber: Yup.string()
              .min(9)
              .max(16)
              .matches(phoneRegExp, 'Please enter a valid phone number')
              .required('Please enter phone number'),
            alternatePhoneNumber: Yup.string()
              .min(9)
              .max(16)
              .matches(phoneRegExp, 'Please enter a valid phone number'),
            roleId: Yup.string().required('Please choose your role'),
          })}
        >
          {({ handleSubmit, isSubmitting, isValid, dirty }) => (
            <Form
              className="ui form error"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <Grid container columns={2}>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    name="displayName"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Display Name"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Display Name"
                    disabled={true}
                  />{' '}
                </Grid.Column>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    disabled
                    name="username"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Username"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"username"
                  />{' '}
                </Grid.Column>
              </Grid>
              <Grid container columns={2}>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  <MySelectInput
                    name="departmentName"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL03 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Department Name"//
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB03 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Department Name" //
                    options={departmentOptions}
                    clearable={false}
                    touched
                    mandatory
                  />
                </Grid.Column>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    disabled={user?.isAdmin === true ? false : true}
                    name="customerName"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL04 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Customer Name"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB04 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Customer Name"
                  />{' '}
                </Grid.Column>
              </Grid>
              <Grid container columns={2}>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    name="addressLine1"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL05 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Address Line 1"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB05 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Address Line 1"
                    touched
                    mandatory
                  />{' '}
                </Grid.Column>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    name="addressLine2"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL06 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Address Line 2"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB06 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Address Line 2"
                  />
                </Grid.Column>
              </Grid>
              <Grid container columns={2}>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    name="phoneNumber"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL07 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Phone Number"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB07 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Phone Number"
                    touched
                    mandatory
                  />
                </Grid.Column>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {' '}
                  <MyTextInput
                    name="alternatePhoneNumber"
                    label={
                      (userLanguage[0].UserViewUserEdit.UVUEL08 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Alternate Phone Number"
                    placeholder={
                      (userLanguage[0].UserViewUserEdit.UVUETB08 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    } //"Alternate Phone Number"
                  />{' '}
                </Grid.Column>
              </Grid>
              <Grid container columns={2}>
                <Grid.Column mobile={16} computer={8} tablet={8}>
                  {!commonStore.filterModeTwo.includes('SRPB01') && (
                    <MyNewSelectInput
                      placeholder={state}
                      name="roleId"
                      options={roleOptions}
                      label={
                        (userLanguage[0].UserViewUserEdit.UVUEL09 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Roles"
                      disabled={commonStore.filterModeZero.includes('SRPB01')}
                      touched
                      mandatory
                    />
                  )}
                </Grid.Column>
              </Grid>
              <Button.Group floated="right" style={{ marginTop: '40px' }}>
                <Button
                  onClick={() =>
                    mediaAssetStore.editModalOpen(false, undefined)
                  }
                  //Cancel
                >
                  {
                    (userLanguage[0].UserViewUserEdit.UVUEB02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }{' '}
                </Button>
                <Button.Or
                  text={
                    (userLanguage[0].UserViewUserEdit.UVUEB03 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                />
                <Button
                  disabled={!dirty}
                  loading={isSubmitting}
                  type="submit"
                  content="Submit"
                  positive
                  //Submit
                >
                  {
                    (userLanguage[0].UserViewUserEdit.UVUEB04 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }{' '}
                </Button>
              </Button.Group>
            </Form>
          )}
        </Formik>
      </Modal.Content>
      <Modal.Actions className="smallscreenedit">
        <Button
          className="setpwdalign"
          disabled={
            !(
              user?.isAdmin || user?.roleName === 'Admin' ||
              ['R4297','R1187','R1509','R1498','R4264'].includes(user?.displayName || "") ||
              (user?.customerName === 'Restoration' &&
                (user?.roleName === 'Resto Admin'   ||
                user?.roleName === 'Process Lead'   ||
                user?.roleName === 'ProcessLead'||
                user?.roleName === 'Restoration Admin'                
              ))
            )
          }
          primary
          style={{ marginTop: '4px' }}
          onClick={resetPassword}
          //Set Default Password
        >
          {
            (userLanguage[0].UserViewUserEdit.UVUEB01 as any)?.[
              `${commonStore.language.key}`
            ]
          }
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
export default observer(EditUser);
